<!--
 * @Author: zhouhx
 * @Date: 2022-04-15 10:46:10
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-02-27 13:47:14
 * @Description:
-->
<template>
  <div class="expert_resources" style="overflow: hidden;">
    <van-nav-bar title="专家首页">
      <template #left></template>
      <template #right>
        <div></div>
      </template>
    </van-nav-bar>
    <div class="banner">
      <img src="../../assets/img_banner02@2x.png" alt="">
    </div>
    <div class="enter_data">
      <div class="enter_data_line" v-for="(item, index) in entranceData" @click.stop="getUrlTo(item)" :key="index">
        <div class="data_container">
          <img class="enter_icon" v-if='item.imgShow' :src="item.icon">
          <img class="enter_icon" v-else :src="item.iconActive">
          <span>{{ item.showName }}</span>
          <img class="enter_icon_url" src="../../assets/btn_24_back@3x.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      entranceData: [],
      hasToken: window.localStorage.getItem('token'),
      orgData: {}
    };
  },
  created () {
    this.orgData = this.$store.state.orgData;
    this.getData();
  },
  methods: {
    getData () {
      this.$axios
        .post('admin/entrance/index/list/user', {
          data: {
            platformId: Number(this.$store.state.systemInfo.id)
          },
          version: 0
        })
        .then((res) => {
          if (res.status) {
            res.data.forEach((item, index) => {
              item.activeClass = false;
              item.iconActive = require('../../assets/enterindex/' +
                item.iconActive);
              item.icon = require('../../assets/enterindex/' + item.icon);
              item.imgShow = true;
            });
            // 只展示 会诊、医教、双向转诊、三方入口；其余不展示
            this.entranceData = []
            res.data.forEach(e => {
              if (e.entranceType === 0) {
                if (e.url === '/apply' || e.url === '/referral_apply' || e.url === '/educate_index/educate' || e.entranceType === 1) {
                  this.entranceData.push(e)
                }
              } else {
                this.entranceData.push(e)
              }
            });
          }
        });
    },
    // 跳转页面
    getUrlTo (data) {
      // if (localStorage.getItem('token')) {
      //   if (this.orgData && this.orgData.createConsultStatus === 0) {
      //     this.$toast('对不起，尚未与该医院开通合作！');
      //     return;
      //   }
      // } else {
      //   this.$store.state.setOrgData = {};
      //   this.$router.push({ path: '/login' });
      //   return;
      // }
      // 已登陆
      if (this.hasToken) {
        localStorage.setItem('url_businessId', 0);
        // 0：系统应用 1：业务应用 2：自定义应用
        if (data.entranceType === 0) {
          this.$router.push({ path: '/index' + data.url });
          this.$store.state.userInfo.userInterface.list.forEach((element) => {
            if (element.url === data.url) {
              this.$store.commit(
                'setRole',
                element.code + '&' + element.url
              );
            }
          });
        } else if (data.entranceType === 1) {
          localStorage.setItem('url_businessId', data.businessId);
          this.$router.push({
            path: '/index/apply',
            query: { businessId: data.businessId }
          });
          this.$store.state.userInfo.userInterface.list.forEach((element) => {
            if (element.url === '/apply') {
              this.$store.commit('setRole', element.code + '&' + element.url);
            }
          });
        } else {
          // window.open(data.url)
          this.$router.push('/weblink');
          const json = {
            url: data.url,
            name: data.showName
          };
          localStorage.setItem('weblink_data', JSON.stringify(json));
        }
      } else {
        this.$router.push({
          path: '/login',
          query: { type: '1' }
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.expert_resources {
  width: 100%;
  // height: 100%;
  clear: both;
  position: absolute;
  top: 10px;
  background: #f8f8f8;

  // padding: 0 12px;
  .banner {
    height: 138px !important;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .enter_data {
    padding: 0 12px;
    clear: both;
    width: 100%;
    margin: 12px auto 0 auto;
    text-align: center;

    .enter_data_line {
      box-shadow: 0px 0px 15px 0px rgb(15 41 97 / 25%);
      border-radius: 8px;
      height: 76px;
      width: 100%;
      margin: 0 0 8px 0;

      .data_container {
        padding: 20px 40px;

        .enter_icon {
          width: 40px;
          float: left;
          margin: 0 16px 0 0;
        }

        .textActive {
          color: #478ff8 !important;
        }

        span {
          display: inline-block;
          width: calc(100% - 56px);
          font-weight: 700;
          font-size: 14px;
          color: #333;
          text-align: left;
          vertical-align: middle;
          padding: 8px 0 0 0;
        }

        .enter_icon_url {
          position: absolute;
          right: 30px;
          width: 24px;
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>

